import { useState } from 'react';
import { useInputsPaged } from '../hooks/useInputs';
import { CreateInputDialog } from '../components/inputs/CreateInputDialog';
import { InputTable } from '../components/inputs/InputsTable';
import { LoadingAnimation } from '@/shared/components/LoadingAnimation';
import { PaginationBar } from '@/components/ui/PaginationBar';

export const InputManagement = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState('');

  const { data, isLoading, error } = useInputsPaged(pageNumber, pageSize, search || undefined);

  const handleSearchChange = (value: string) => {
    setSearch(value);
    setPageNumber(1);
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setPageNumber(1);
  };

  if (isLoading && !data) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load inputs</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Inputs</h1>
          <p className="text-gray-500 mt-1">
            Manage inventory inputs and products
          </p>
        </div>
        <CreateInputDialog />
      </div>

      <InputTable
        inputs={data?.items ?? []}
        search={search}
        onSearchChange={handleSearchChange}
      />

      {data && (
        <PaginationBar
          currentPage={data.currentPage}
          pageSize={data.pageSize}
          totalCount={data.totalCount}
          totalPages={data.totalPages}
          onPageChange={setPageNumber}
          onPageSizeChange={handlePageSizeChange}
        />
      )}
    </div>
  );
};
